import React, { useState } from "react";
import Helmet from "react-helmet";
import { AppName, CleanMessage } from "../../../../util/app";
import { ReadData } from "../../../../providers/Patient.Provider";
import { useQuery, useMutation } from "react-apollo";
import { GET_PATIENT_DISCHARGE, NEW_PATIENT_DISCHARGE, CONFIRM_DISCHARGE } from "../../../../queries/discharge.query";
import { toast } from "react-toastify";
import LoadingSpinner from "../../../../partials/loading";
import NewPatientDischarge from "./NewDischarge";
import DischargeDetail from "./DischargeDetail";

const PatientDischarge = ({ match }) => {
    const title = "Patient Discharge";
    const [newDischarge, setNewDischarge] = useState(false);
    const [discharge, setDischarge] = useState(null);

    // patient id
    const { id } = match.params;
    // patient object
    const patient = ReadData();

    function scrollTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    const { loading } = useQuery(GET_PATIENT_DISCHARGE, {
        onError: (e) => {
            // toast.error(CleanMessage(e.message));
            setNewDischarge(true);
            setDischarge(null);
        },
        onCompleted: (d) => {
            const { doc } = d.GetPatientDischarge;
            setDischarge(doc);
            setNewDischarge(false);
        },
        variables: { patient: id },
    });

    const [dischargeFunc, { loading: disLoading }] = useMutation(NEW_PATIENT_DISCHARGE, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (data) => {
            const { doc, message } = data.NewPatientDischarge;
            toast.success(message);
            if (doc.confirm.status) {
                //
                window.document.location.href = "/home/patient/profile/" + id;
            } else {
                setDischarge(doc);
                setNewDischarge(false);
                scrollTop();
            }
        },
    });
    const [confirmDischargeFunc, { loading: conLoading }] = useMutation(CONFIRM_DISCHARGE, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (data) => {
            const { message } = data.ConfirmPatientDischarge;
            toast.success(message);
            window.document.location.href = "/home/clinical-note/ward-summary";
        },
    });

    return (
        <>
            <Helmet>
                <title>
                    {title} | {AppName}
                </title>
            </Helmet>

            <div className="row">
                <div className="col-12">
                    <LoadingSpinner loading={loading} />
                </div>
                {newDischarge && !discharge && (
                    <div className="col-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>New {title}</header>
                            </div>
                            <div className="card-body" style={{ minHeight: "480px" }}>
                                <NewPatientDischarge
                                    onSend={async ({ _model, confirmed }) => {
                                        await dischargeFunc({ variables: { model: { ..._model, patient: id, admission: patient.lastAdmission }, confirmed } });
                                    }}
                                />
                                <LoadingSpinner loading={disLoading} />
                            </div>
                        </div>
                    </div>
                )}
                {!newDischarge && discharge && (
                    <div className="col-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>{title} Detail</header>
                            </div>
                            <div className="card-body" style={{ minHeight: "480px" }}>
                                <DischargeDetail
                                    item={discharge}
                                    onConfirm={async () => {
                                        if (window.confirm("Are you sure you want to proceed?")) {
                                            await confirmDischargeFunc({ variables: { id: discharge.id } });
                                        }
                                    }}
                                />
                                <LoadingSpinner loading={conLoading} />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default PatientDischarge;
